module.exports = __webpack_public_path__ + "1dd6b85d46393b1eebbfa039a2a0f376.pdf";